import { Button, Modal } from "antd";
export const QuickFilterDeleteModal = ({
  deleteTemplateDetails,
  handleOk,
  handleCancel,
}) => {
  return (
    <Modal
      title={""}
      open={deleteTemplateDetails?.showModal}
      onOk={handleOk}
      onCancel={handleCancel}
      footer={[
        <Button
          type="button"
          className="btn_Clear"
          style={{ minWidth: "5.6rem" }}
          onClick={() => handleCancel("no")}
        >
          NO
        </Button>,
        <Button
          type="primary"
          className="ant-btn-primary_blue"
          onClick={() => handleOk("yes")}
        >
          YES
        </Button>,
      ]}
      width={480}
      style={{ marginRight: "2rem" }}
      closable={true}
      maskClosable={true}
      bodyStyle={{ padding: "3rem" }}
    >
      <div className="text_heading-Slab text-transform__none">
        Are you sure, you want to delete ?
      </div>
    </Modal>
  );
};
